// Professional
export const PROFESSIONAL_PRINT_SERVICE_PRICE = 10; //€ per jaw
export const PROFESSIONAL_CANCELLATION_PRICE = 149;

export const PROFESSIONAL_REFINEMENT_SMALL_PACKAGE_PRICE = 149;
export const PROFESSIONAL_REFINEMENT_LARGE_PACKAGE_PRICE = 199;
export const PROFESSIONAL_REFINEMENT_DATA_PACKAGE_PRICE = 99;

// Functional
export const FUNCTIONAL_REFINEMENT_SMALL_PACKAGE_PRICE = 149;
export const FUNCTIONAL_REFINEMENT_LARGE_PACKAGE_PRICE = 199;
export const FUNCTIONAL_CANCELLATION_PRICE = 149;

